export default __webpack_public_path__ + "static/media/AttenderCheckOut.95b8861a.svg";